import { Navigate } from "react-router-dom";
import { useLoanCentricSidebarNavEnabled } from "hooks/useLoanCentricSidebarNavEnabled";
import SettingsShellLayout from "../settings-shell-layout/SettingsShellLayout";

/**
 * Flag-gated /settings entry. When loan-centric IA is off, send borrowers home
 * (Settings dock/route only exist under LoanCentricSidebarNavEnabled).
 */
const SettingsRoute = () => {
  const loanCentricSidebarNavEnabled = useLoanCentricSidebarNavEnabled();

  if (!loanCentricSidebarNavEnabled) {
    return <Navigate to="/home" replace />;
  }

  return <SettingsShellLayout />;
};

export default SettingsRoute;
